var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M501.3,199.6c-1.7-5.2-6.2-9-11.6-9.8l-152.5-22.2L268.9,29.4c-2.4-4.9-7.4-8-12.9-8c-5.5,0-10.5,3.1-12.9,8\n\tl-68.2,138.2L22.3,189.7c-5.4,0.8-9.9,4.6-11.6,9.8c-1.7,5.2-0.3,10.9,3.6,14.8l110.4,107.6l-26,151.9c-0.9,5.4,1.3,10.9,5.7,14.1\n\tc2.5,1.8,5.5,2.8,8.5,2.8c2.3,0,4.6-0.5,6.7-1.7L256,417.3L392.4,489c4.9,2.6,10.7,2.1,15.2-1.1c4.4-3.2,6.7-8.7,5.7-14.1\n\tl-26.1-151.9l110.4-107.6C501.6,210.5,503,204.8,501.3,199.6z"}));
}

Star.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = Star;

Star.default = Star;
